 const modelstate = {
	state: {
		modelshow1: false,
		modelshow2: false,
	},
	getters:{
        modelshow1(state){//这里的state对应着上面这个state
            return state.modelshow1;
        },
        modelshow2(state){//这里的state对应着上面这个state
            return state.modelshow2;
        }
    },
	mutations:{
		SWITCHSHOW1(state,flag){
		console.log("mutations内"+state.modelshow1);
            state.modelshow1 = flag
		},
		SWITCHSHOW2(state,flag){
            state.modelshow2 = flag
		}
	},
	actions: {
		switchshow1(context, flag){
            context.commit('SWITCHSHOW1', flag)
		},
		switchshow2(context, flag){
            context.commit('SWITCHSHOW2', flag)
		}
	}
};		
export default modelstate



// WEBPACK FOOTER //
// ./src/store/modelstate.js